import React, { Component } from "react";
import { connect } from 'react-redux';
import Highlighter from "react-highlight-words";
import moment from "moment";
import { toast } from 'react-toastify';

/* for "axios" request cancelation */
import axios from 'axios';

/* Helpers */
import { history } from '../../../helpers/history';

/* Services */
import ParentService from "../../../services/parent.service";

/* Ant Design */
import { Typography, Table, Button, Input, Space, Col, Card, Row, Image, Tabs, Tooltip, Divider, Modal, List } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

/* for "axios" request cancelation check variable */
let source;

class PatientsGameDatas extends Component {
    constructor(props) {
        super(props);
        this.getGameDatas = this.getGameDatas.bind(this);
        this.onTableRowExpand = this.onTableRowExpand.bind(this);
        this.onChangePage = this.onChangePage.bind(this);

        this.state = {
            patients: null,
            loading: true,
            queryPage: 1,
            queryLimit: 10,
            GameDataTotalLength: null,
            dataCount: null
        };

        history.listen((location) => {
            props.patientDispatch.clearPatient();
            props.doctorDispatch.clearDoctor();
        });
    }

    componentDidMount() {
        /* Component Mount olurken source'a token iletilir */
        source = axios.CancelToken.source();

        const query = new URLSearchParams(this.props.location.search);
        const page = query.get('page');
        const limit = query.get('limit');
        if (parseInt(page) > 0) {
            this.setState({ queryPage: page });
            if (limit > 10) {
                this.setState({ queryLimit: limit });
            }
            this.getGameDatas(page, limit, source.token);
        } else {
            this.getGameDatas('1', '10', source.token);
        }
    }

    /* for Search */
    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`${dataIndex} Arayın`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Ara
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Temizle
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filtrele
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    /* for Search */
    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    /* for Search Reset */
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    /* Table Columns */
    dataColumns = [
        /* AdSoyad */
        {
            title: 'Ad - Soyad',
            dataIndex: 'AdSoyad',
            key: 'AdSoyad',
            defaultSortOrder: 'ascend',
            sorter: (a, b) => a.AdSoyad.localeCompare(b.AdSoyad),
            sortDirections: ['ascend', 'descend', 'ascend'],
            responsive: ["xs", "sm", "md", "lg"],
            ...this.getColumnSearchProps('AdSoyad'),
        },
        /* Data Count */
        {
            title: 'Veri Sayısı',
            dataIndex: 'VeriSayisi',
            key: 'VeriSayisi',
            defaultSortOrder: 'ascend',
            sorter: (a, b) => a.VeriSayisi - b.VeriSayisi,
            sortDirections: ['ascend', 'descend', 'ascend'],
            responsive: ["xs", "sm", "md", "lg"],
            ...this.getColumnSearchProps('VeriSayisi'),
        },
    ];

    /* Parent's Patients' Games' Datas */
    getGameDatas(page, limit, cancelToken) {
        this.setState({ loading: true });
        ParentService.getPatientsGameDatas(page, limit, cancelToken).then(
            res => {
                this.props.history.push({
                    pathname: '',
                    search: '?page=' + page + '&limit=' + limit
                });
                this.setState({
                    GameDataTotalLength: res.data.GameDataTotalLength,
                    dataCount: res.data.dataCount
                });
                const doubleModelled = res.data.GameData?.map(data => {
                    const reModelledGameDatas = data.GameDatas.map(gamedata => {
                        return {
                            ...gamedata,
                            key: gamedata._id,
                            CoordinatesLength: gamedata.Coordinates,
                            SessionTime: gamedata.TotalPlayedTime ? (Math.floor(gamedata.TotalPlayedTime / 60)) : (Math.floor((new Date(gamedata.EndTime) - new Date(gamedata.StartTime)) / 60e3)),
                            StartTime: moment(new Date(gamedata.StartTime)).format('LLL'),
                            EndTime: moment(new Date(gamedata.EndTime)).format('LLL'),
                            TransferTime: moment(new Date(gamedata.TransferTime)).format('LLL'),
                        }
                    });
                    return {
                        ...data,
                        key: data._id,
                        VeriSayisi: reModelledGameDatas.length,
                        GameDatas: reModelledGameDatas
                    }
                });

                this.setState({ patients: doubleModelled, loading: false });
            },
            err => {
                const resMessage =
                    (err.response &&
                        err.response.data &&
                        err.response.data.message) ||
                    err.message ||
                    err.toString();

                if (resMessage !== 'Cancel') {
                    toast.error(resMessage);
                }
                // this.setState({ loading: false });
            }
        )
    }

    onChangePage(page, limit) {
        const query = new URLSearchParams(this.props.location.search);
        const queryPage = query.get('page');
        const queryLimit = query.get('limit');
        if (parseInt(page) === 0) {
            page = 1;
        }
        if (parseInt(limit) === 0) {
            limit = 10;
        }
        if ((parseInt(page) !== parseInt(queryPage)) || (parseInt(limit) !== parseInt(queryLimit))) {
            this.getGameDatas(page, limit, source.token);
        }
    }

    onTableRowExpand(expanded, record) {
        var keys = [];
        if (expanded) {
            keys.push(record._id);
        }

        this.setState({ expandedRowKeys: keys });
    }

    componentWillUnmount() {
        /* Component Unmount edilirken cancel triggerı tetiklenir */
        if (source) {
            source.cancel();
        }
    }

    render() {
        let gamesCount = 0;
        let dataCount = 0;
        let gamesTimesCount = 0;
        let calculationCount = 0;
        let modalVisible = this.state.modalVisible;

        function info(_id, OyunAdi, calculations) {
            calculationCount = 0;
            Modal.info({
                title: OyunAdi,
                visible: (modalVisible === _id + OyunAdi),
                content: (
                    <Row gutter={[8, 32]} style={{ width: '100%' }}>
                        {calculations.map(calculation => {
                            return (
                                <Col span={6}>
                                    <List size="larger" bordered style={((calculationCount + 1) % 2 === 0) ? { backgroundColor: '#e6f7ff' } : { backgroundColor: '#fff' }}>
                                        <List.Item>
                                            <Typography.Title level={5}><b>{calculationCount + 1}.&nbsp;Köşe</b></Typography.Title>
                                        </List.Item>
                                        {/* FOCSR - FOCSRNumerator */}
                                        <List.Item>
                                            <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>FOCSR: </Typography.Text>
                                                    <Typography.Text>{calculation.FOCSR}</Typography.Text>
                                                </Col>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>FOCSRNumerator: </Typography.Text>
                                                    <Typography.Text>{calculation.FOCSRNumerator}</Typography.Text>
                                                </Col>
                                            </Row>
                                        </List.Item>
                                        {/* FOCSRDenominator - FOTA */}
                                        <List.Item>
                                            <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>FOCSRDenominator: </Typography.Text>
                                                    <Typography.Text>{calculation.FOCSRDenominator}</Typography.Text>
                                                </Col>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>FOTA: </Typography.Text>
                                                    <Typography.Text>{calculation.FOTA}</Typography.Text>
                                                </Col>
                                            </Row>
                                        </List.Item>
                                        {/* FOTANumerator - FOTADenominator */}
                                        <List.Item>
                                            <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>FOTANumerator: </Typography.Text>
                                                    <Typography.Text>{calculation.FOTANumerator}</Typography.Text>
                                                </Col>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>FOTADenominator: </Typography.Text>
                                                    <Typography.Text>{calculation.FOTADenominator}</Typography.Text>
                                                </Col>
                                            </Row>
                                        </List.Item>
                                        {/* FOTSR - FOTSRNumerator */}
                                        <List.Item>
                                            <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>FOTSR: </Typography.Text>
                                                    <Typography.Text>{calculation.FOTSR}</Typography.Text>
                                                </Col>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>FOTSRNumerator: </Typography.Text>
                                                    <Typography.Text>{calculation.FOTSRNumerator}</Typography.Text>
                                                </Col>
                                            </Row>
                                        </List.Item>
                                        {/* FOTSRDenominator - AFOFT */}
                                        <List.Item>
                                            <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                            <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>FOTSRDenominator: </Typography.Text>
                                                    <Typography.Text>{calculation.FOTSRDenominator}</Typography.Text>
                                                </Col>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>AFOFT: </Typography.Text>
                                                    <Typography.Text>{calculation.AFOFT}</Typography.Text>
                                                </Col>
                                            </Row>
                                        </List.Item>
                                        {/* AFOFTNumerator - AFOFTDenominator */}
                                        <List.Item>
                                            <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>AFOFTNumerator: </Typography.Text>
                                                    <Typography.Text>{calculation.AFOFTNumerator}</Typography.Text>
                                                </Col>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>AFOFTDenominator: </Typography.Text>
                                                    <Typography.Text>{calculation.AFOFTDenominator}</Typography.Text>
                                                </Col>
                                            </Row>
                                        </List.Item>
                                    </List>
                                    <p style={{ display: 'none' }}>{calculationCount++}</p>
                                </Col>
                            )
                        })}
                    </Row>
                ),
                onOk() { },
                width: '100%'
            })
        }

        return (
            <div>
                <Typography.Title level={1} style={{ textAlign: "center" }}>Hasta Oyun Verileri</Typography.Title>
                <Space direction="horizontal" align="end" style={{ width: '100%', justifyContent: 'right' }}>
                    <Button type="primary" disabled={this.state.loading} onClick={() => this.getGameDatas(new URLSearchParams(this.props.location.search).get('page'), new URLSearchParams(this.props.location.search).get('limit'), source.token)} style={{ marginBottom: '2vh', width: 100 }}>
                        Yenile
                    </Button>
                </Space>
                <Space direction="horizontal" align="end" style={{ width: '100%', justifyContent: 'right' }}>
                    {this.state.patients &&
                        <div>
                            {this.state.patients.forEach(patient =>
                                patient.GameDatas.forEach(data =>
                                    dataCount++
                                )
                            )}
                            <Typography.Text style={{ textAlign: 'starts', marginTop: '1vh' }}><b>{dataCount}</b> Adet Veriye Ulaşıldı!</Typography.Text>
                        </div>
                    }
                </Space>
                <Table
                    columns={this.dataColumns}
                    dataSource={this.state.patients ? this.state.patients : null}
                    expandable={{
                        expandedRowRender: record => (
                            <Tabs defaultActiveKey="1">
                                <Tabs.TabPane tab="Oyun Verileri" key="1">
                                    <div style={{ maxHeight: 500, overflowY: 'scroll', overflowX: 'hidden' }}>
                                        <Row gutter={[8, 32]} style={{ marginTop: '2vh', marginRight: '1vh' }}>
                                            {/* Burada sıfırlama yapmadığımız takdirde, 
                                screen size her değiştiğinde,
                                responsive olan kartlar yeniden render ediliyor
                                ,count her değişimde artıyor */}
                                            <p style={{ display: 'none' }}>{gamesCount = 0}</p>
                                            {record.GameDatas.map(gamedata => (
                                                <Col xs={24} md={12} lg={8} xl={6} xxl={4} key={gamedata._id} style={{ display: 'flex' }}>
                                                    <Card
                                                        size="small"
                                                        cover={
                                                            <Image
                                                                preview={false}
                                                                width={'100%'}
                                                                src={gamedata.GameID.PhotoLink}
                                                                alt={gamedata.GameID.OyunAdi}
                                                                fallback="data:image/png;base64,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"
                                                            />
                                                        }
                                                        style={((gamesCount + 1) % 2 === 0) ? {
                                                            backgroundColor: '#e6f7ff', borderRadius: "20px",
                                                            overflow: "hidden"
                                                        } : {
                                                            backgroundColor: '#FFFFFF', borderRadius: "20px",
                                                            overflow: "hidden"
                                                        }}
                                                    >
                                                        <Card.Meta
                                                            title={
                                                                <Tooltip title={gamedata.GameID.OyunAdi}>
                                                                    <Typography.Title level={5}>
                                                                        <Typography.Text style={{ fontWeight: 'bold' }}>{gamesCount + 1}) {gamedata.GameID.OyunAdi}</Typography.Text>
                                                                    </Typography.Title>
                                                                </Tooltip>
                                                            }
                                                            description={
                                                                <div>
                                                                    <Typography>
                                                                        <Typography.Text><b>Koordinat Sayısı: </b>{gamedata.CoordinatesLength}</Typography.Text>
                                                                        <br />
                                                                        <Typography.Text><b>Oturum Süresi: </b>{gamedata.SessionTime < 1 ? '1' : gamedata.SessionTime} dk</Typography.Text>
                                                                        <br />
                                                                        <Typography.Text><b>Başlangıç Zamanı: </b>{gamedata.StartTime}</Typography.Text>
                                                                        <br />
                                                                        <Typography.Text><b>Bitiş Zamanı: </b>{gamedata.EndTime}</Typography.Text>
                                                                        <br />
                                                                        <Typography.Text><b>Transfer Zamanı: </b>{gamedata.TransferTime}</Typography.Text>
                                                                    </Typography>
                                                                    <Divider />
                                                                </div>
                                                            }
                                                        />
                                                        <Space style={{ width: '100%', justifyContent: 'center' }}>
                                                            {gamedata.Calculations.length > 0 ?
                                                                <Button type='primary' onClick={() => { this.setState({ modalVisible: gamedata._id + gamedata.GameID.OyunAdi }); info(gamedata._id, gamedata.GameID.OyunAdi, gamedata.Calculations); }} style={{ width: '100%' }} block>Hesaplamaları Göster</Button>
                                                                :
                                                                <Button type='primary' disabled={true} style={{ width: '100%' }} block>Hesaplamaları Göster</Button>
                                                            }
                                                        </Space>
                                                    </Card>
                                                    <p style={{ display: 'none' }}>{gamesCount += 1}</p>
                                                </Col>
                                            ))}
                                        </Row>
                                    </div>
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="Toplam Oynama Süreleri" key="2">
                                    <div style={{ maxHeight: 400, overflowY: 'scroll', overflowX: 'hidden' }}>
                                        <Row gutter={[8, 32]} style={{ marginTop: '2vh', marginRight: '1vh' }}>
                                            {/* Burada sıfırlama yapmadığımız takdirde, 
                                screen size her değiştiğinde,
                                responsive olan kartlar yeniden render ediliyor
                                ,count her değişimde artıyor */}
                                            <p style={{ display: 'none' }}>{gamesTimesCount = 0}</p>
                                            {record.GameTimeDatas.map(gameTimeData => (
                                                <Col xs={24} md={12} lg={8} xl={6} xxl={4} key={gameTimeData._id} style={{ display: 'flex' }}>
                                                    <Card
                                                        size="small"
                                                        cover={
                                                            <Image
                                                                preview={false}
                                                                width={'100%'}
                                                                src={gameTimeData.PhotoLink}
                                                                alt={gameTimeData.OyunAdi}
                                                                fallback="data:image/png;base64,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"
                                                            />
                                                        }
                                                        style={((gamesTimesCount + 1) % 2 === 0) ? {
                                                            backgroundColor: '#e6f7ff', borderRadius: "20px",
                                                            overflow: "hidden"
                                                        } : {
                                                            backgroundColor: '#FFFFFF', borderRadius: "20px",
                                                            overflow: "hidden"
                                                        }}
                                                    >
                                                        <Card.Meta
                                                            title={
                                                                <Tooltip title={gameTimeData.OyunAdi}>
                                                                    <Typography.Title level={5}>
                                                                        <Typography.Text style={{ fontWeight: 'bold' }}>{gamesTimesCount + 1}) {gameTimeData.OyunAdi}</Typography.Text>
                                                                    </Typography.Title>
                                                                </Tooltip>
                                                            }
                                                            description={
                                                                <Typography>
                                                                    <Typography.Text><b>Toplam Oynama Süresi: </b>{Math.floor(gameTimeData.TotalPlayedTime / 60) > 0 ? (Math.floor(gameTimeData.TotalPlayedTime / 60) + " dk") : "1 dk'dan az"}</Typography.Text>
                                                                </Typography>
                                                            }
                                                        />
                                                    </Card>
                                                    <p style={{ display: 'none' }}>{gamesTimesCount += 1}</p>
                                                </Col>
                                            ))}
                                        </Row>
                                    </div>
                                </Tabs.TabPane>
                            </Tabs>
                        ),
                        rowExpandable: record => record.AdSoyad !== 'Not Expandable',
                    }}
                    expandedRowKeys={this.state.expandedRowKeys}
                    onExpand={this.onTableRowExpand}
                    // pagination={false}
                    pagination={{ pageSize: 10, hideOnSinglePage: true }}
                    // pagination={{ pageSize: 1000, hideOnSinglePage: true }}
                    loading={this.state.loading}
                />
                {/* <Space direction="horizontal" align="end" style={{ width: '100%', justifyContent: 'right' }}>
                    <Pagination
                        hideOnSinglePage={true}
                        defaultCurrent={1}
                        total={this.state.GameDataTotalLength}
                        pageSizeOptions={[10, 20, 50]}
                        showSizeChanger={true}
                        onChange={(page, limit) => this.onChangePage(page, limit)}
                        style={{ marginTop: '16px' }}
                    />
                </Space> */}
            </div >
        )
    }
}

const mapState = (state) => ({
    patient: state.patient,
    doctor: state.doctor,
});

const mapDispatch = (dispatch) => ({
    patientDispatch: dispatch.patient,
    doctorDispatch: dispatch.doctor,
});

export default connect(mapState, mapDispatch)(PatientsGameDatas);